// Sidebar menu (Bootstrap Icons class names)
const MENU = [
  // {
  //   key: 'components',
  //   label: 'menu.components',
  //   icon: 'bi-puzzle',
  //   children: [
  //     { 
  //       key: 'tables-components', 
  //       label: 'menu.tables', 
  //       icon: 'bi-table', 
  //       roles: ['admin'], 
  //       view: 'components/Tables' 
  //     },
  //     { 
  //       key: 'notifications-components', 
  //       label: 'menu.notifications', 
  //       icon: 'bi-bell', 
  //       roles: ['admin'], 
  //       view: 'components/Notifications' 
  //     },
  //     { 
  //       key: 'form-components', 
  //       label: 'menu.form', 
  //       icon: 'bi-file-earmark-text', 
  //       roles: ['admin'], 
  //       view: 'components/Form' 
  //     }
  //   ]
  // },
   { 
        key: '404', 
        label: 'menu.orderManagement', 
        view: 'components/NotFound',
        hidden: true
      },
  {
    key: 'trip-mgmt',
    label: 'menu.tripManagement',
    icon: 'bi-truck',
    children: [
      { 
        key: 'order-management', 
        label: 'menu.orderManagement', 
        icon: 'bi-clipboard-check', 
        module: 'order-management',
        view: 'trip/OrderManagement' 
      },
      { 
        key: 'waybill-entry', 
        label: 'menu.waybillEntry', 
        icon: 'bi-receipt', 
        view: 'trip/WaybillEntry', 
        module: 'waybill-entry',

      },
      { 
        key: 'order-dispatching-plan', 
        label: 'menu.orderDispatchingPlan', 
        icon: 'bi-list-task',
        module: 'order-dispatching-plan',
        view: 'trip/OrderDispatchingPlan' 
      },
      { 
        key: 'transport-status', 
        label: 'menu.transportStatus', 
        icon: 'bi-truck', 
        module: 'transport-status',
        view: 'trip/TransportStatus' 
      },
      { 
        key: 'dispatch-management', 
        label: 'menu.dispatchManagement', 
        icon: 'bi-box-seam',
        module: 'dispatch-management',
        view: 'trip/DispatchManagement' 
      },
      { 
        key: 'status-waiting-vehicles', 
        label: 'menu.statusWaitingVehicles', 
        icon: 'bi-clock-history', 
        module: 'status-waiting-vehicles',
        view: 'trip/StatusWaitingVehicles' 
      },
      { 
        key: 'status-vehicles-scheduled-return', 
        label: 'menu.statusVehiclesScheduledReturn', 
        icon: 'bi-arrow-return-left', 
        module: 'status-vehicles-scheduled-return',
        view: 'trip/StatusScheduledVehiclesReturn' 
      },
      { 
        key: 'm-traffic-accident', 
        label: 'menu.trafficAccident', 
        icon: 'bi-exclamation-diamond', 
        module: 'm-traffic-accident',
        view: 'master/MTrafficAccident' 
      },
      { 
        key: 'm-payment', 
        label: 'menu.payment', 
        icon: 'bi-credit-card', 
        module: 'm-payment', 
        view: 'master/MPayment'
      },
    ]
  },
  {
    key: 'container-mgmt',
    label: 'menu.containerManagement',
    icon: 'bi-box',
    children: [
      { 
        key: 'container-info', 
        label: 'menu.containerInformation', 
        icon: 'bi-info-circle', 
        module: 'container-info',
        view: 'container/ContainerInfo' 
      },
      { 
        key: 'container-inout', 
        label: 'menu.containerInOutStatus', 
        icon: 'bi-arrow-left-right', 
        module: 'container-inout',
        view: 'container/ContainerInOut' 
      },
      // { 
      //   key: 'rfid-receive', 
      //   label: 'RFID Data Receive', 
      //   icon: 'bi-broadcast', 
      //   roles: ['admin'], 
      //   view: 'container/RfidReceive' 
      // }
    ]
  },
  {
    key: 'tarif',
    label: 'menu.tarif',
    icon: 'bi-currency-dollar',
    children: [
      { 
        key: 'selling-tarif', 
        label: 'menu.sellingTarif', 
        icon: 'bi-tag', 
        module: 'selling-tarif',
        view: 'tarif/SellingTarif' 

      },
      { 
        key: 'buying-tarif', 
        label: 'menu.buyingTarif', 
        icon: 'bi-cash-stack', 
        module: 'buying-tarif',
        view: 'tarif/BuyingTarif' 
      }
    ]
  },
  {
    key: 'report',
    label: 'menu.report',
    icon: 'bi-graph-up',
    children: [
      {
        key: 'vehicle-trip-status',
        label: 'menu.vehicleTripStatus',
        icon: 'bi-speedometer2',
        module: 'vehicle-trip-status',
        view: 'report/VehicleTripStatus'
      },
      {
        key: 'vehicle-status',
        label: 'menu.vehicleStatus',
        icon: 'bi-truck',
        module: 'vehicle-status',
        view: 'report/VehicleStatus'
      },
      {
        key: 'vehicle-usage-status',
        label: 'menu.vehicleUsageStatus',
        icon: 'bi-graph-up',
        module: 'vehicle-usage-status',
        view: 'report/VehicleUsageStatus'
      },
      {
        key: 'transportation-status-by-period',
        label: 'menu.transportationStatusByPeriod',
        icon: 'bi-calendar-range',
        module: 'transportation-status-by-period',
        view: 'report/TransportationStatusByPeriod'
      },
      {
        key: 'transportation-status-by-shipper',
        label: 'menu.transportationStatusByShipper',
        icon: 'bi-building',
        module: 'transportation-status-by-shipper',
        view: 'report/TransportationStatusByShipperVendor'
      },
      {
        key: 'dispatch-management-by-shipper',
        label: 'menu.dispatchManagementByShipper',
        icon: 'bi-diagram-3',
        module: 'dispatch-management-by-shipper',
        view: 'report/DispatchManagementByShipper'
      },
      {
        key: 'summary-trip-by-shipper',
        label: 'menu.summaryTripByShipper',
        icon: 'bi-journal-check',
        module: 'summary-trip-by-shipper',
        view: 'report/SummaryTripByShipper'
      },
      {
        key: 'vehicle-location-check',
        label: 'menu.vehicleLocationCheck',
        icon: 'bi-geo-alt',
        module: 'vehicle-location-check',
        view: 'report/VehicleLocationCheck'
      },
      {
        key: 'transportation-status-by-driver',
        label: 'menu.transportationStatusByDriver',
        icon: 'bi-person-vcard',
        module: 'transportation-status-by-driver',
        view: 'report/TransportationStatusByDriver'
      },
      {
        key: 'transportation-status-by-location',
        label: 'menu.transportationStatusByLocation',
        icon: 'bi-geo-alt',
        module: 'transportation-status-by-location',
        view: 'report/TransportationStatusByLocation'
      },
      {
        key: 'transportation-status-by-vehicle',
        label: 'menu.transportationStatusByVehicle',
        icon: 'bi-truck',
        module: 'transportation-status-by-vehicle',
        view: 'report/TransportationStatusByVehicle'
      },
      {
        key: 'report-maintenance-vehicle',
        label: 'menu.reportMaintenanceVehicle',
        icon: 'bi-gear',
        module: 'report-maintenance-vehicle',
        view: 'report/ReportMaintenanceVehicle'
      },
      {
        key: 'report-traffic-accident',
        label: 'menu.reportTrafficAccident',
        icon: 'bi-exclamation-diamond',
        module: 'report-traffic-accident',
        view: 'report/ReportTrafficAccident'
      },
      {
        key: 'forecasted-performance',
        label: 'menu.forecastedPerformance',
        icon: 'bi-graph-up-arrow',
        module: 'forecasted-performance',
        view: 'report/ForecastedPerformance'
      }
    ]
  },
  {
    key: 'master',
    label: 'menu.master',
    icon: 'bi-database',
    children: [
      { key: 'm-vehicle', label: 'menu.vehicle', icon: 'bi-truck', module: 'm-vehicle', view: 'master/MVehicle' },
      { key: 'm-driver', label: 'menu.driver', icon: 'bi-person-vcard', module: 'm-driver', view: 'master/MDriver' },
      { key: 'm-customer', label: 'menu.customer', icon: 'bi-people', module: 'm-customer', view: 'master/MCustomer' },
      { key: 'm-location', label: 'menu.location', icon: 'bi-geo-alt', module: 'm-location', view: 'master/MLocation' },
      { key: 'm-route', label: 'menu.route', icon: 'bi-signpost-split', module: 'm-route', view: 'master/MRoute' },
      { key: 'm-cargo-type', label: 'menu.cargoType', icon: 'bi-dropbox', module: 'm-cargo-type', view: 'master/MCargoType' },
      { key: 'm-cargo-detail', label: 'menu.cargoDetail', icon: 'bi-box-seam', module: 'm-cargo-detail', view: 'master/MCargoDetail' },
      { key: 'm-tariff-unit-management', label: 'menu.tariffUnitManagement', icon: 'bi-credit-card', module: 'm-tariff-unit-management', view: 'master/MTariffUnitManagement' },
      { key: 'm-local-custom-charge', label: 'menu.localCustomCharge', icon: 'bi-receipt', module: 'm-local-custom-charge', view: 'master/MLocalCustomCharge' },
      { key: 'm-mailing-list', label: 'menu.mailingList', icon: 'bi-list-ul', module: 'm-mailing-list', view: 'master/MMailingList' },

      // sudah ada module → tetap
      { key: 'm-user', label: 'menu.user', icon: 'bi-people', module: 'm-user', action: 'read', view: 'master/MUser' },

      { key: 'm-country', label: 'menu.country', icon: 'bi-globe-americas', module: 'm-country', view: 'master/MCountry' },
      { key: 'm-currency', label: 'menu.currency', icon: 'bi-currency-dollar', module: 'm-currency', view: 'master/MCurrency' },
      { key: 'm-division', label: 'menu.division', icon: 'bi-diagram-3', module: 'm-division', view: 'master/MDivision' },
      { key: 'm-container-code', label: 'menu.containerCode', icon: 'bi-truck', module: 'm-container-code', view: 'master/MContainerCode' },
      { key: 'm-item', label: 'menu.item', icon: 'bi-box-seam', module: 'm-item', view: 'master/MItem' },
      { key: 'm-role', label: 'menu.role', icon: 'bi-shield-lock', module: 'm-role', view: 'master/MRole' },
      { key: 'm-export-queue', label: 'menu.exportQueue', icon: 'bi-cloud-arrow-up', module: 'm-export-queue', view: 'master/MExportQueue' }
    ]
  },
  {
  key: 'system',
  label: 'menu.system',
  icon: 'bi-gear',
  children: [
    { key: 'code-generator', label: 'menu.codeGenerator', icon: 'bi-hash', module: 'code-generator', view: 'system/CodeGenerator' },
    { key: 'mailing-rule', label: 'menu.mailingRule', icon: 'bi-envelope-gear', module: 'mailing-rule', view: 'system/MailingRule' },
    { key: 'authorization', label: 'menu.authorization', icon: 'bi-shield-lock', module: 'authorization', view: 'system/Authorization' },
    { key: 'app-version-management', label: 'menu.appVersionManagement', icon: 'bi-phone', module: 'app-version-management', view: 'system/AppVersionManagement' },
    { key: 'system-setting', label: 'menu.systemSetting', icon: 'bi-sliders', module: 'system-setting', view: 'system/SystemSetting' },
    { key: 'interface-setting', label: 'menu.interfaceSetting', icon: 'bi-usb-plug', module: 'interface-setting', view: 'system/InterfaceSetting' },
    { key: 'interface-gps-log', label: 'menu.interfaceGpsLog', icon: 'bi-geo-alt', module: 'interface-gps-log', view: 'system/InterfaceGpsLog' }
  ]
},
{
  key: 'documentation-section',
  label: 'menu.documentation',
  icon: 'bi-journal-text',
  children: [
    { key: 'documentation', label: 'menu.documentation', icon: 'bi-journal-text', view: 'Documentation' }
  ]
}

]

export default MENU

// Helper: filter menu by roles (intersection check)
export function filterMenuByRoles(roles = []) {
  const set = new Set(roles)
  const hasRole = (itemRoles) => !itemRoles || itemRoles.length === 0 || itemRoles.some(r => set.has(r))
  return MENU.map(section => ({
    ...section,
    children: (section.children || []).filter(item => hasRole(item.roles))
  })).filter(section => section.children && section.children.length > 0)
}

// Helper: translate menu labels using i18n
// export function translateMenu(menu, t) {
//   return menu.map(section => ({
//     ...section,
//     label: t(section.label),
//     children: section.children ? section.children.map(item => ({
//       ...item,
//       label: t(item.label)
//     })) : undefined
//   }))
// }

export function translateMenu(menu, t, permissions = []) {
  const hasModule = (module) => {
  if (!module) return true;

  return permissions.some(p =>
    p === `${module}:read` || p === `${module}:*`
  );
};

  return menu
    .map(section => {
      const children = (section.children || [])
        .filter(item => {
          if (item.hidden) return false;

          const allowed = hasModule(item.module);
          return allowed;
        })
        .map(item => ({
          ...item,
          label: t(item.label),
        }));

      if (children.length === 0) return null;

      return {
        ...section,
        label: t(section.label),
        children,
      };
    })
    .filter(Boolean);
}
